import { unwrappedPremiumSubscribersAtom } from '@/atoms/premium'
import { HugeiconsIcon } from '@hugeicons/react'
import { TicketStarIcon } from '@hugeicons/core-free-icons'
import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'

export default function PremiumSubscriberBadge({ pubkey }: { pubkey: string }) {
  const { t } = useTranslation()
  const subscribers = useAtomValue(unwrappedPremiumSubscribersAtom)

  const kind = subscribers?.get(pubkey)
  if (!kind) return null

  return (
    <div
      className="rounded-full bg-muted p-0.5 flex items-center"
      title={
        kind === 'direct' ? t('Premium subscriber (direct)') : t('Premium subscriber (delegated)')
      }
    >
      <HugeiconsIcon icon={TicketStarIcon} className="!size-3" />
    </div>
  )
}
